// extracted by mini-css-extract-plugin
export var childrenContainer = "_4b-0";
export var virtualScrollArea = "_4b-1";